import { Stack, type StackProps } from '@mui/material';

interface IProps extends StackProps {
  id?: string;
}

export const VerticalScrolledPanel = (props: IProps) => {
  const { id, children, width, maxWidth, ...rest } = props;

  return (
    <Stack
      id={id}
      // sx={{ overflowY: 'auto', height: '100%' }}
      flexGrow={1}
      height={0}
      width={1}
      maxWidth={maxWidth}
      sx={[
        { overflowY: 'auto', scrollbarGutter: 'stable', overscrollBehaviorX: 'contain' },
        {
          '&:hover': {
            overflowY: 'auto',
          },
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          },
          transition: 'all 0.3s',
        },
      ]}
    >
      <Stack {...rest}>{children || ''}</Stack>
    </Stack>
  );
};
